import React from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { Badge } from "@repo/ui";
import { getFieldIcon } from "../utils/field-utils";
import { Field } from "@/services/entity-view.service";
import { DataTypeEnum } from "@/services/entity.service";

interface SortablePaletteFieldProps {
  field: Field;
}

export function SortablePaletteField({ field }: SortablePaletteFieldProps) {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id: field.id,
    data: { field, fromPalette: true },
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      {...listeners}
      {...attributes}
      className={`flex cursor-grab items-center gap-2 rounded-lg border bg-white p-3 transition-all hover:shadow-sm ${
        isDragging ? "opacity-50" : ""
      }`}
    >
      {getFieldIcon(field.icon as DataTypeEnum)}
      <span className="text-sm font-medium">{field.name}</span>
      <Badge variant="secondary" className="ml-auto text-xs">
        {field.type}
      </Badge>
    </div>
  );
}
